import { GridProduct, IconicColor, SkinProductOption } from '../types/productTypes'
import { BaseProductTypeOrderMap, ColorSortOrderMap } from './SortOrders'
import { getSkinSlotCount } from './productUtils'

export function sortByBaseProductType(a: SkinProductOption, b: SkinProductOption): number {
  return BaseProductTypeOrderMap[a.type] - BaseProductTypeOrderMap[b.type]
}

export function sortByColor<T extends { color: IconicColor | null }>(a: T, b: T): number {
  return (a.color ? ColorSortOrderMap[a.color] : 1000)
  - (b.color ? ColorSortOrderMap[b.color] : 1000)
}

export function sortByGridProperties(a: SkinProductOption, b: SkinProductOption): number {
  const gridA = a.gridProduct
  const gridB = b.gridProduct
  if (gridA && gridB) {
    return (
      // sort by gang no asc
      (gridA.gangNo ?? 0) - (gridB.gangNo ?? 0)
    ) || (
      // if gang no is the same, sort by (configurable) slot count desc
      // configurable products will appear first, e.g. Architraves appear after regular switches
      getSkinSlotCount(a) - getSkinSlotCount(b)
    ) || (
      (gridA.socketNo ?? 0) - (gridB.socketNo ?? 0)
    )
  } else if (a.gridProduct) {
    return -1
  } else if (b.gridProduct) {
    return 1
  }

  return 0
}

export function sortByItemNo(a: GridProduct, b: GridProduct): number {
  if (a.baseItemNo && b.baseItemNo) {
    return (a.baseItemNo ?? '').localeCompare(b.baseItemNo ?? '')
      // sort comparison names 0-9, should show lower amps as default
      || (
        a.comparisonName && b.comparisonName
          ? (a.comparisonName ?? '').localeCompare(b.comparisonName ?? '')
          : 0
      )
      || a.itemNo.localeCompare(b.itemNo)
  }

  return 0
}
